export default __webpack_public_path__ + "static/sdg-15-9c602548bc45c36f45535fccf151dced.png";